<template>
  <div class="markdown-message">
    <MarkdownIt
      class="markdown-message__content"
      :content="markdown"
    />

    <details
      v-if="hasReasoning"
      class="markdown-message__reasoning"
    >
      <summary class="markdown-message__reasoning-summary">
        {{ $t('copilot.showReasoning') }}
      </summary>
      <MarkdownIt
        class="markdown-message__reasoning-content"
        :content="reasoningMarkdown"
      />
    </details>
  </div>
</template>

<script>
import MarkdownIt from '@baserow/modules/core/components/MarkdownIt'

export default {
  name: 'MarkdownMessage',
  components: {
    MarkdownIt,
  },
  props: {
    markdown: {
      type: String,
      required: true,
    },
    reasoningMarkdown: {
      type: String,
      required: false,
      default: '',
    },
    streaming: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    hasReasoning() {
      return this.reasoningMarkdown && this.reasoningMarkdown.trim().length > 0
    },
  },
}
</script>

<style scoped lang="scss">
.markdown-message__content {
  font-size: 13px;
  line-height: 1.5;
}

.markdown-message__reasoning {
  margin-top: 4px;
  font-size: 12px;
}

.markdown-message__reasoning-summary {
  cursor: pointer;
  color: #666;
}
</style>

